export default __webpack_public_path__ + "static/media/Montserrat-Medium.5db21347.woff2";